/**
 * Config
 * Global configuration settings
 */
export const Config = {
  // Debug mode
  debug: false,

  // Performance settings
  performance: {
    maxFPS: 60,            // Target FPS
    maxPixelRatio: 2,      // Maximum pixel ratio
    lowPerformanceMode: false // Set to true for lower-end devices
  },

  // Camera settings
  camera: {
    fov: 35,               // Field of view
    near: 0.1,             // Near plane
    far: 1000,             // Far plane
    initialPosition: {     // Initial camera position
      x: 0,
      y: 0,
      z: 20
    }
  },

  // Scroll settings
  scroll: {
    smooth: true,          // Use smooth scrolling
    lerpFactor: 0.08,      // Lower for smoother, higher for more responsive
    multiplier: 1,         // Scroll multiplier
    mobileMultiplier: 0.8, // Scroll multiplier for mobile

    // Locomotive options
    locomotive: {
      lerp: 0.08,        // Locomotive lerp value
      smoothMobile: true, // Use smooth scrolling on mobile
      smoothTablet: true, // Use smooth scrolling on tablet
    }
  },

  // Section settings
  sections: {
    transitionSpeed: 0.1,  // Section transition speed (higher = faster)
    animationSpeed: 0.5,   // Animation speed multiplier
    colors: [              // Default section colors
      '#3a86ff', // Blue
      '#06d6a0', // Teal
      '#ff006e', // Pink
      '#ffbe0b', // Yellow
      '#8338ec'  // Purple
    ]
  },

  // Background settings
  backgrounds: {
    useShaders: true,      // Use shader materials
    wireframe: true,       // Use wireframe for 3D objects
    opacity: 1.0,          // Background opacity - increase from 0.8 to 1.0
    orbitSpeed: 0.5,       // Orbit speed for circle objects
    rotationSpeed: 0.01    // Rotation speed for circle objects
  },

  // Rendering settings
  renderer: {
    antialias: true,       // Use antialiasing
    alpha: true,           // Use alpha
    shadows: false,        // Enable shadows
    outputEncoding: 'sRGB' // Output encoding
  },

  // Responsive breakpoints
  breakpoints: {
    mobile: 768,           // Mobile max width
    tablet: 1024,          // Tablet max width
  },

  // DOM element IDs
  dom: {
    canvas: 'three-container',      // Canvas ID
    scrollContainer: '[data-scroll-container]', // Scroll container selector
    sections: '[data-section]'      // Section selector
  }
};
